import EditableCell from './EditableCell';

const Table = {};
Table.EditableCell = EditableCell;

export default Table;
